var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoPlayer",staticClass:"video-js vjs-16-9",staticStyle:{"width":"100%"},style:({ visibility : _vm.isPlaying ? 'visible' : 'hidden' }),attrs:{"id":'video'}})}
var staticRenderFns = []

export { render, staticRenderFns }